<script>
    import NoContentCard from './NoContentCard.svelte';
    import {ApiEndpoints} from './urls';
    import Spinner from '../Spinner.svelte';
    import WorkRequestsTable from '../DataGrid/WorkRequestsTable.svelte';
    import {sgettext} from '../../i18n.js';
    import InfiniteScroll from './InfiniteScroll.svelte';

    import {homePageSize} from "./columnConstants";

    export let branch;
    export let branchId;
    import {checked} from './HomePage.svelte';
    import {
        dashBoardWorkCentreId,
    } from './dashBoardStrore.js';


    $: url = ApiEndpoints.failedInstancesList + `?limit=${homePageSize}&branch=${branchId}&end_time=true&end_time_gte=${addMonths(new Date(), -6)}&checked=${$checked}&work_centre=${$dashBoardWorkCentreId}`;

    function addMonths(date, months) {
        date.setMonth(date.getMonth() + months);
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }

    $: data = [];
    $: newBatch = [];
    let count = 0;
    let totalRecords = 0;
    let loading = false;
    let stickyHeader = true;
    let page = 1;

    async function initialFetch() {
        data = [];
        newBatch = [];
        loading = true;
        page = 1;
        await fetchData();
        loading = false;
    }


    async function fetchData() {
        const offset = (page - 1) * homePageSize;
        const response = await fetch(`${url}&offset=${offset}`);
        if (response.ok) {
            const json = await response.json();
            newBatch = await json.results;
            totalRecords = json.count;
            count = count + newBatch.length;
            page = page + 1;
        }
    };

    $: !loading && (data = [
        ...data,
        ...newBatch
    ]);

    $: ($checked != null || $dashBoardWorkCentreId >= 0) && initialFetch()

</script>

<style>
    .schedule-failed-table {
        width: 100%;
    }

    .schedule-failed-table :global(tr) {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    .schedule-failed-table :global(tbody) {
        display: block;
        max-height: 500px;
        overflow-y: scroll;
    }

    .schedule-failed-table :global(::-webkit-scrollbar) {
        -webkit-appearance: none;
        width: 7px;
    }

    .schedule-failed-table :global(::-webkit-scrollbar-track) {
        background: #f2f4f5;
    }

    .schedule-failed-table :global(::-webkit-scrollbar-thumb) {
        background: #888;
    }
</style>

<div class="card">
    {#if !loading && totalRecords === 0}
        <NoContentCard iconName="fa fa-calendar fa-3x" header={sgettext('$$FAILED_INSTANCES$$')}
                       subHeader={sgettext('$$FAILED_INSTANCES_1$$')}></NoContentCard>
    {:else}
        <div class="card-body p-0 small">
            {#if loading}
                <div>
                    <Spinner homePage="true"/>
                </div>
            {:else}
                <div class="schedule-failed-table">
                    <WorkRequestsTable
                        defaultCellValue='-'
                        small={true}
                        hover={true}
                        rows={data}
                        {stickyHeader}
                    >
                        <InfiniteScroll
                            slot="infiniteScroll"
                            hasMore={newBatch.length}
                            threshold={100}
                            on:loadMore={async() => {
                    if(totalRecords > count){
                        await fetchData()
                    }
                    }}/>
                    </WorkRequestsTable>
                </div>
            {/if}
        </div>
    {/if}
</div>



